// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero073_wrapper__ktMrT","block":"Hero073_block__vrHch","headline":"Hero073_headline__mbzNq","description":"Hero073_description__wx06r"};